import { createChunks } from '@/util/array';
import { styled } from '@mui/material/styles';
import MiniButton from '../Button/MiniButton';
import type { DateRange, PresetOption } from './types';

interface PresetProps {
  preset: PresetOption;
  active: boolean;
  onClick: (range: DateRange) => void;
}

export const Preset = ({ preset, active, onClick }: PresetProps) => {
  const { label, fn } = preset;

  return (
    <MiniButton
      onClick={() => {
        const { from, to } = fn();
        onClick({ from, to });
      }}
      disabled={active}
      sx={({ palette }) => {
        if (!active) {
          return {};
        }

        return {
          color: palette.getContrastText(palette.background.inverted),
          '&.Mui-disabled': {
            background: palette.background.inverted,
            color: palette.getContrastText(palette.background.inverted),
          },
        };
      }}
    >
      {label}
    </MiniButton>
  );
};

const ListContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.5),
}));

const ListRowContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(1),
}));

interface PresetListProps {
  presets: PresetOption[];
  value: string | undefined;
  onChange: (value: DateRange) => void;
}

export const PresetList = ({ presets, value, onChange }: PresetListProps) => {
  const chunks = createChunks(presets, 2);

  return (
    <ListContainer>
      {chunks.map((chunk, i) => (
        <ListRowContainer key={i}>
          {chunk.map((preset) => (
            <Preset
              preset={preset}
              active={value === preset.value}
              onClick={onChange}
              key={preset.value}
            />
          ))}
        </ListRowContainer>
      ))}
    </ListContainer>
  );
};
